import { createFileRoute } from '@tanstack/react-router'
import { requireTrainer } from '@/lib/auth-guards'
import { SettingsTrainerProfile } from '@/features/settings/trainer-profile'

export const Route = createFileRoute(
  '/_authenticated/settings/trainer-profile'
)({
  beforeLoad: async () => {
    await requireTrainer()
  },
  component: SettingsTrainerProfile,
})
